<div class="vox-table companies-table">
  <table>
    <thead>
      <tr>
        <td translate>companies.table.header.id</td>
        <td translate>companies.table.header.name</td>
        <td translate>companies.table.header.alphaname</td>
        <td translate>companies.table.header.email</td>
        <td translate>companies.table.header.dids</td>
        <td translate>companies.table.header.pbxid</td>
        <td translate>companies.table.header.billingid</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <ng-container *ngFor="let c of companies">
        <tr class="company-data-row">
          <td>{{c.companyId}}</td>
          <td class="text-left">
            <b class="mr-2 ml-1">{{c.name}}</b>
            <span class="company-icons">
              <i [ngbTooltip]="'companies.filters.hasFax'| translate" *ngIf="c.hasFax" class="icon-small-fax"></i>
              <i [ngbTooltip]="'companies.filters.hasRecordings'| translate" *ngIf="c.hasRecordings"
                class="icon-small-voicemail"></i>
            </span>
          </td>
          <td>{{c.alphaname}}</td>
          <td>{{c.email}}</td>
          <td class="dids">
            <b *ngIf="!c.didNumbers || (c.didNumbers && c.didNumbers.length === 0)">-</b>
            <ul *ngIf="c.didNumbers && c.didNumbers.length !== 0">
              <li *ngFor="let d of c.didNumbers">
                <i [ngClass]="DID_ICON_CLASS[d.class]"></i>
                {{d.number}}
              </li>
            </ul>
          </td>
          <td>{{c.pbxId}}</td>
          <td>{{c.billingId}}</td>
        </tr>
        <tr class="actions-row">
          <td colspan="7">
            <div class="actions">
              <button (click)="openControlPanel(c, ENV.PRODUCTION)" class="vox-btn btn btn-success" translate>
                companies.table.actions.prod-controlpanel
              </button>
              <button (click)="openControlPanel(c, ENV.STAGING)" class="vox-btn btn btn-warning" translate>
                companies.table.actions.staging-controlpanel
              </button>
              <button *ngIf="canWipLogin" class="vox-btn btn btn-info login-wip" (click)="openWipLoginPopup(c)">
                <i class="fa fa-wrench"></i>
              </button>
              <ngx-skeleton-loader *ngIf="c.locking || c.unlocking"
                [theme]="{'margin-bottom': '-3px', 'width': '180px', 'height':'34px'}"></ngx-skeleton-loader>
              <button (click)="lockCompany(c)" *ngIf="!c.locked && !c.locking" [disabled]="isDisabledLock(c)"
                class="vox-btn btn btn-danger" translate>
                companies.table.actions.lock
                <i *ngIf="isDisabledLock(c)" [ngbTooltip]="'companies.tooltip-lock'| translate"
                  class="icon-small-info"></i>
              </button>
              <button (click)="unlockCompany(c)" *ngIf="c.locked && !c.unlocking" class="vox-btn btn btn-danger"
                translate>
                companies.table.actions.unlock
              </button>
              <ngx-skeleton-loader *ngIf="c.deleting"
                [theme]="{'margin-bottom': '-3px', 'width': '180px', 'height':'34px'}"></ngx-skeleton-loader>
              <button *ngIf="!c.deleting" [disabled]="!c.locked || c.readOnly" (click)="deleteCompany(c)"
                class="vox-btn btn btn-danger">
                <span translate>companies.table.actions.delete</span>
                <i *ngIf="!c.locked" [ngbTooltip]="'companies.table.actions.delete-info' | translate"
                  class="icon-small-info"></i>
              </button>
              <button class="vox-btn vox-btn-secondary" [routerLink]="['./',c.companyId]" translate>
                companies.table.actions.details
              </button>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tbody *ngIf="loading">
      <tr *ngFor="let i of [1,2,3,4,5,6]">
        <td colspan="7">
          <ngx-skeleton-loader></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && companies.length === 0">
      <tr>
        <td colspan="7" translate>companies.table.empty</td>
      </tr>
    </tbody>
  </table>
</div>
